/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snapshot_History_TitleInputs */



/**
* | output |
* | --- |
* | "Commit History" |
*
* @param {Snapshot_History_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snapshot_history_title = /** @type {((inputs?: Snapshot_History_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snapshot_History_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Historique des commits")
	if (locale === "de") return /** @type {LocalizedString} */ ("Commit-Historie")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cronologia degli impegni")
	if (locale === "ru") return /** @type {LocalizedString} */ ("История коммитов")
	if (locale === "es") return /** @type {LocalizedString} */ ("Historial de confirmaciones")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("提交历史记录")
	if (locale === "ja") return /** @type {LocalizedString} */ ("コミット履歴")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रतिबद्धता इतिहास")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Histórico de Compromissos")
	return /** @type {LocalizedString} */ ("Commit History")
});